// TaskPriorityChip — MD3 Chip с цветом по приоритету задачи.
// LOW=нейтральный (серый), MEDIUM=primary (синий), HIGH=warning (оранжевый), CRITICAL=error (красный).
// R41 / U-16: подпись приоритета через i18n (formatTaskPriority, ключи tasks.priority.*).
import { Chip } from '@mui/material';
import type { TaskPriority } from '@/api/tasks';
import { t } from '@/i18n';
import { formatTaskPriority } from '@/lib/format';

/** Сопоставление приоритета → MD3 color. */
const PRIORITY_COLORS: Record<TaskPriority, 'default' | 'primary' | 'warning' | 'error'> = {
  LOW: 'default',
  MEDIUM: 'primary',
  HIGH: 'warning',
  CRITICAL: 'error',
};

interface TaskPriorityChipProps {
  /** Приоритет задачи. */
  priority: TaskPriority;
  /** Размер чипа (small по умолчанию). */
  size?: 'small' | 'medium';
}

/** MD3 Chip для отображения приоритета задачи. */
export function TaskPriorityChip({ priority, size = 'small' }: TaskPriorityChipProps): JSX.Element {
  return (
    <Chip
      data-testid="task-priority-chip"
      label={formatTaskPriority(priority, t)}
      color={PRIORITY_COLORS[priority]}
      size={size}
      variant="outlined"
    />
  );
}
